import { useEffect, useLayoutEffect } from 'react';

/**
 * Hook that provides isomorphic layout effects for server-side rendering compatibility.
 * Uses useLayoutEffect on the client for synchronous DOM mutations, and useEffect on the server
 * to avoid React hydration warnings. Prevents the "useLayoutEffect does nothing on the server" warning.
 *
 * @param {React.EffectCallback} effect - The effect callback function.
 * @param {React.DependencyList} [deps] - Optional dependency array for the effect.
 * @returns {void}
 */
export const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;
